<div class="flex flex-col gap-1 md:block hidden">
    @if(rightSidePanel()?.length){
        @for(banner of rightSidePanel(); track $index){
            <a
                [href]="banner.redirectUrl"
                target="_blank"
                class="flex items-center justify-center my-2"> 
                <img [src]="banner?.images?.desktop + imgVersionParams"/>
            </a>
        }
    }
    <!-- @if(rightSidePanel()?.images?.desktop){
        <a
            [class.hidden]="!showBanner()"
            [href]="rightSidePanel()?.redirectUrl"
            target="_blank"
            class="flex items-center justify-center my-1"> 
            <img [src]="rightSidePanel()?.images?.desktop + imgVersionParams"/>
        </a>
    }
    <div>
        @if(proBanner().rightImage){
            <a
                [class.hidden]="!showBanner()"
                [href]="proBanner().url"
                target="_blank"
                class="flex items-center justify-center my-1"> 
                <img [src]="proBanner().rightImage + imgVersionParams"/>
            </a>
        }
    </div> -->
    <!-- <div class="hidden md:block">
        <app-advertise adId="ad-left" slotName="/52892455/bdjobs/aubjAssmntb2c728x90" [sizes]="[[160, 600]]">
        </app-advertise>
    </div> -->
    <!-- <div class="hidden md:block">
        <app-advertise adId="ad-left-1" slotName="/52892455/bdjobs/aubjAssmntb2c728x90" [sizes]="[[160, 600]]">
        </app-advertise>
    </div> -->
</div>

@if(resolvedPopupBanner() && showPopup()){
    <div
        class="fixed inset-0 bg-black/40 bg-opacity-60 flex items-center justify-center z-[9999]" (click)="closePop()">
        <div class="relative w-full max-w-[80vw] sm:max-w-fit md:max-w-fit rounded-lg shadow-lg"
            >
            <button (click)="closePop()"
                class="absolute -top-5 -right-4 md:top-2 md:right-2 cursor-pointer text-gray-600 hover:text-black text-xl bg-white p-2 py-0.5 rounded-[50%]">
                &times;
            </button>
            <div (click)="redirectFromPop(resolvedPopupBanner()?.redirectUrl ?? '')" target="_blank"
                class="flex items-center justify-center my-1 cursor-pointer">
    
                <img [src]="isMobileDevice() ? resolvedPopupBanner()?.images?.mobile : resolvedPopupBanner()?.images?.desktop + imgVersionParams"
                 loading="lazy"
                 [alt]="resolvedPopupBanner()?.name"
                 class="max-w-full h-auto" />
            </div>
    
        </div>
    </div>
}



